'use client';

import { useSuspenseQuery } from '@apollo/client';
import { BlogItem } from './BlogItem';
import { ShowPost } from '@/query';

const BlogsPage = ({ slug, hideBlog }) => {
  const { data } = useSuspenseQuery(ShowPost, {
    variables: { slug },
    errorPolicy: 'ignore',
  });

  return <BlogItem slug={slug} item={data?.showPost} hideBlog={hideBlog} />;
};

export default BlogsPage;
